import { render } from "./ExamImageTab.vue?vue&type=template&id=4e23b664&scoped=true"
import script from "./ExamImageTab.js?vue&type=script&lang=js&external"
export * from "./ExamImageTab.js?vue&type=script&lang=js&external"

import "./ExamImageTab.vue?vue&type=style&index=0&id=4e23b664&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e23b664"]])

export default __exports__